import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import { HelmetProvider } from "react-helmet-async";
import Loader from "./components/Home/Loader";

const Home = lazy(() => import("./components/Home/Home"));
const AboutUs = lazy(() => import("./components/AboutUs/AboutUs"));
const Experiences = lazy(() => import("./components/Experiences/Experiences"));
const Careers = lazy(() => import("./components/Careers/Careers"));
const KitchenStories = lazy(() =>
  import("./components/KitchenStories/KitchenStories")
);
const HotAndCrusty = lazy(() =>
  import("./components/HotAndCrusty/HotAndCrusty")
);
const Gravity = lazy(() => import("./components/Gravity/Gravity"));
const Blogs = lazy(() => import("./components/Blogs/Blogs"));
const EventGallery = lazy(() =>
  import("./components/EventGallery/EventGallery")
);
const AccessoryEvents = lazy(() =>
  import("./components/EventGallery/AccessoryEvents")
);
const ApparelEvents = lazy(() =>
  import("./components/EventGallery/ApparelEvents")
);
const AutomobileEvents = lazy(() =>
  import("./components/EventGallery/AutomobileEvents")
);
const CorporateEvents = lazy(() =>
  import("./components/EventGallery/CorporateEvents")
);
const SocialEvents = lazy(() =>
  import("./components/EventGallery/SocialEvents")
);
const Birthday = lazy(() =>
  import("./components/EventGallery/SocialEvents/Birthday")
);
const Weddings = lazy(() =>
  import("./components/EventGallery/SocialEvents/Weddings")
);
const More = lazy(() => import("./components/EventGallery/SocialEvents/More"));
const Blog1 = lazy(() => import("./components/Blogs/Blog1"));
const Blog2 = lazy(() => import("./components/Blogs/Blog2"));
const Blog3 = lazy(() => import("./components/Blogs/Blog3"));
const Blog4 = lazy(() => import("./components/Blogs/Blog4"));
const Blog5 = lazy(() => import("./components/Blogs/Blog5"));
const Blog6 = lazy(() => import("./components/Blogs/Blog6"));
const Blog7 = lazy(() => import("./components/Blogs/Blog7"));
const Blog8 = lazy(() => import("./components/Blogs/Blog8"));
const Blog9 = lazy(() => import("./components/Blogs/Blog9"));
const Blog10 = lazy(() => import("./components/Blogs/Blog10"));
const Blog11 = lazy(() => import("./components/Blogs/Blog11"));
const Blog12 = lazy(() => import("./components/Blogs/Blog12"));
const Blog13 = lazy(() => import("./components/Blogs/Blog13"));
const Blog14 = lazy(() => import("./components/Blogs/Blog14"));

const Inquire = lazy(() => import("./components/Inquire/Inquire"));
const TermsAndConditions = lazy(() =>
  import("./components/TermsAndConditions/TermsAndConditions")
);
const RefundPolicy = lazy(() =>
  import("./components/RefundPolicy/RefundPolicy")
);
const DataPrivacyAndSecurityPrivacy = lazy(() =>
  import(
    "./components/DataPrivacyAndSecurityPrivacy/DataPrivacyAndSecurityPrivacy"
  )
);
const Tijori = lazy(() => import("./components/Tijori/Tijori"));

const Page404 = lazy(() => import("./components/404Page/Page404"));

const Test = lazy(() => import("./components/Home/Test"));

// import Home from "./components/Home/Home";
// import AboutUs from "./components/AboutUs/AboutUs";
// import Experiences from "./components/Experiences/Experiences";
// import Careers from "./components/Careers/Careers";
// import KitchenStories from "./components/KitchenStories/KitchenStories";
// import HotAndCrusty from "./components/HotAndCrusty/HotAndCrusty";
// import Gravity from "./components/Gravity/Gravity";
// import Blogs from "./components/Blogs/Blogs";
// import EventGallery from "./components/EventGallery/EventGallery";
// import AccessoryEvents from "./components/EventGallery/AccessoryEvents";
// import ApparelEvents from "./components/EventGallery/ApparelEvents";
// import AutomobileEvents from "./components/EventGallery/AutomobileEvents";
// import CorporateEvents from "./components/EventGallery/CorporateEvents";
// import SocialEvents from "./components/EventGallery/SocialEvents";
// import Birthday from "./components/EventGallery/SocialEvents/Birthday";
// import Weddings from "./components/EventGallery/SocialEvents/Weddings";
// import More from "./components/EventGallery/SocialEvents/More";
// import Blog1 from "./components/Blogs/Blog1";
// import Blog2 from "./components/Blogs/Blog2";
// import Blog3 from "./components/Blogs/Blog3";
// import Blog4 from "./components/Blogs/Blog4";
// import Blog5 from "./components/Blogs/Blog5";
// import Blog6 from "./components/Blogs/Blog6";
// import Blog7 from "./components/Blogs/Blog7";
// import Inquire from "./components/Inquire/Inquire";
// import TermsAndConditions from "./components/TermsAndConditions/TermsAndConditions";
// import RefundPolicy from "./components/RefundPolicy/RefundPolicy";
// import DataPrivacyAndSecurityPrivacy from "./components/DataPrivacyAndSecurityPrivacy/DataPrivacyAndSecurityPrivacy";

// import Test from "./components/Home/Test";

function App() {
  return (
    <div>
      <Router>
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/Loader" element={<Loader />} />

            <Route path="/Home" element={<Home />} />
            <Route path="/AboutUs" element={<AboutUs />} />
            <Route path="/Experiences" element={<Experiences />} />
            <Route path="/Careers" element={<Careers />} />
            <Route path="/KitchenStories" element={<KitchenStories />} />
            <Route path="/HotAndCrusty" element={<HotAndCrusty />} />
            <Route path="/Gravity" element={<Gravity />} />
            <Route path="/Blogs" element={<Blogs />} />
            <Route path="/EventGallery" element={<EventGallery />} />
            <Route path="/AccessoryEvents" element={<AccessoryEvents />} />
            <Route path="/ApparelEvents" element={<ApparelEvents />} />
            <Route path="/AutomobileEvents" element={<AutomobileEvents />} />
            <Route path="/CorporateEvents" element={<CorporateEvents />} />
            <Route path="/SocialEvents" element={<SocialEvents />} />
            <Route path="/Birthday" element={<Birthday />} />
            <Route path="/Weddings" element={<Weddings />} />
            <Route path="/More" element={<More />} />
            <Route path="/Inquire" element={<Inquire />} />
            <Route
              path="/TermsAndConditions"
              element={<TermsAndConditions />}
            />
            <Route path="/RefundPolicy" element={<RefundPolicy />} />
            <Route
              path="/DataPrivacyAndSecurityPrivacy"
              element={<DataPrivacyAndSecurityPrivacy />}
            />
            <Route path="/Tijori" element={<Tijori />} />

            <Route
              path="/top-3-unique-experiences-you-get-only-at-rpj-hotel-rajkot"
              element={<Blog1 />}
            />
            <Route
              path="/a-culinary-escape-inside-the-multitude-cuisines-dining-experience-at-rpj-hotel"
              element={<Blog2 />}
            />
            <Route
              path="/the-ultimate-business-leisure-stay"
              element={<Blog3 />}
            />
            <Route
              path="/family-friendly-features-at-rpj-hotel-a-home-away-from-home"
              element={<Blog4 />}
            />
            <Route
              path="/from-check-in-to-chill-how-to-maximise-your-24-hours-at-rpj"
              element={<Blog5 />}
            />
            <Route
              path="/top-5-attractions-near-rpj-hotel-you-cannot-miss"
              element={<Blog6 />}
            />
            <Route
              path="/a-luxurious-stay-at-rpj-hotel-what-to-expect"
              element={<Blog7 />}
            />
            <Route
              path="/host-like-a-pro-planning-your-rajkot-event-at-rpj-hotel"
              element={<Blog8 />}
            />
            <Route
              path="/the-ultimate-wedding-venue-in-rajkot-why-couples-choose-rpj-hotel"
              element={<Blog9 />}
            />
            <Route
              path="/a-weekend-getaway-in-rajkot-stay-relax-and-dine-at-rpj-hotel"
              element={<Blog10 />}
            />
            <Route
              path="/inside-the-luxurious-rooms-and-suites-of-rpj-hotel"
              element={<Blog11 />}
            />
            <Route
              path="/exploring-the-flavours-of-rajkot-at-rpj-hotels-signature-restaurant"
              element={<Blog12 />}
            />
            <Route
              path="/top-6-must-try-dishes-at-rpj-hotels-kitchen"
              element={<Blog13 />}
            />
            <Route
              path="/hosting-your-dream-wedding-at-rpj-hotel-complete-guide"
              element={<Blog14 />}
            />

            <Route path="*" element={<Page404 />} />

            <Route path="/Test" element={<Test />} />
          </Routes>
        </Suspense>
      </Router>
    </div>
  );
}

export default App;
